var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 9.14089H12.17L7.29 14.0209C6.9 14.4109 6.9 15.0509 7.29 15.4409C7.68 15.8309 8.31 15.8309 8.7 15.4409L15.29 8.85089C15.68 8.46089 15.68 7.83089 15.29 7.44089L8.71 0.840886C8.52317 0.653634 8.26952 0.548401 8.005 0.548401C7.74048 0.548401 7.48683 0.653634 7.3 0.840886C6.91 1.23089 6.91 1.86089 7.3 2.25089L12.17 7.14089H1C0.45 7.14089 0 7.59089 0 8.14089C0 8.69089 0.45 9.14089 1 9.14089Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.a5367489cae7dc701f3745f6dd33c756.svg";
export { ForwardRef as ReactComponent };